import { ButtonBase, styled, Typography } from '@mui/material'
import { useCallback } from 'react'
import { t } from '$i18n'
import { EMOJI_SPRITE_SHEET } from '$helper/constants/emoji'
import { sendTextMessage } from '$logic/message'
import { useOpenedRoomId } from '$logic/opened-room'
import { Separator } from './shared/separator'

interface Props {
  withSeparator?: boolean
}

interface Props {
  withSeparator?: boolean
}
export function PVOnboarding({ withSeparator }: Props) {
  const openedRoomId = useOpenedRoomId()
  const handleSendWelcomeSticker = useCallback(() => {
    if (openedRoomId) sendTextMessage('😍', undefined, openedRoomId, 'PV')
  }, [openedRoomId])
  return (
    <>
      <Root sx={{ px: '20px', pt: withSeparator ? '20px' : 0 }}>
        <Container>
          <EmojiButton onClick={handleSendWelcomeSticker}>
            <em-emoji
              native="😍"
              set="apple"
              spritesheeturl={EMOJI_SPRITE_SHEET}
              spritesheet
              size={64} // TODO: use app font or rem or scale for zoom option
            />
          </EmojiButton>
          <DescriptionContainer>
            <Typography
              variant="subtitle1"
              color="neutral900"
              textAlign="center"
            >
              {t(`message.onboarding.pv.title`)}
            </Typography>
            <Typography
              textAlign="center"
              variant="paragraph3"
              color="neutral800"
            >
              {t(`message.onboarding.pv.description`)}
            </Typography>
          </DescriptionContainer>
        </Container>
      </Root>

      {withSeparator && <Separator />}
    </>
  )
}

const Root = styled('div')`
  background-color: transparent;
  display: flex;
  justify-content: center;
`

const Container = styled('div')`
  background-color: ${({ theme }) => theme.palette.neutral000};
  box-shadow: ${({ theme }) => theme.shadows[3]};
  border-radius: 12px;
  padding: 20px;
  gap: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 320px;
`

const DescriptionContainer = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
`

const EmojiButton = styled(ButtonBase)`
  width: 64px;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  border-radius: 50%;
`
